import { stayGreenDuringHolidayDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getstayGreenDuringHolidayEn = () => {
  const data = stayGreenDuringHolidayDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addstayGreenDuringHoliday = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-can-i-stay-green-during-the-holidays`,
    ) &&
    document.getElementById(`stayGreenDuringHolidayJSONLD`) === null
  ) {
    const script = stayGreenDuringHolidayJSONLDEn()
    addJSONLDToHead(script, `stayGreenDuringHolidayJSONLD`)
  } else {
    removeElement(`stayGreenDuringHolidayJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const stayGreenDuringHolidayJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getstayGreenDuringHolidayEn(),
  }
  return FaqBagsterTemplate
}
